export const error = ({ theme: { colors }, padding }) => ({
    color: colors.primary,
    fontSize: '16px',
    lineHeight: 1.56,
    padding,
    display: 'flex',
    justifyContent: 'flex-end',
});
